import React, { useContext } from "react";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Card,
  Flex,
  Heading,
  VStack,
} from "@chakra-ui/react";
import { IoIosRocket } from "react-icons/io";
import { LuWallet } from "react-icons/lu";
import { FaPlusSquare } from "react-icons/fa";
import Loader from "../../../utils/Loader/Loader";
import { AgencyContext } from "../AgencyProvider/AgencyProvider";
import ExtrasSection from "./ExtrasSection";
import WalletCoupon from "./WalletCoupon";
import PlansSection from "./PlansSection";
import useBillingPlans from "./BilingHook";

const Billing = () => {
  const agency = useContext(AgencyContext);
  const { myDetails, textColor, agencyData } = agency;

const isSalesBtnisvisible = agency.loading
  ? false
  : myDetails?.agency_id
  ? myDetails?.wallet === true
  : true;


  const {
    billingPlans,
    userDetails,
    isLoading,
    coupanBillingPlans,
    setIsLoading,
  } = useBillingPlans();
  console.log(agencyData?.billing_plan,myDetails,"<><>")
  const sections = [
    ...(isSalesBtnisvisible
      ? [
          {
            id: "walletCoupon",
            title: (
              <Flex alignItems="center" gap={2}>
                <LuWallet />
                Your Wallet
              </Flex>
            ),
            component: (
              <WalletCoupon
                isSalesBtnisvisible={isSalesBtnisvisible}
                userDetails={userDetails}
                coupanBillingPlans={coupanBillingPlans}
              />
            ),
          },
        ]
      : []),
    {
      id: "plans",
      title: (
        <Flex alignItems="center" gap={2}>
          <IoIosRocket />
          {isSalesBtnisvisible ? "Boosters" : "Plans"}
        </Flex>
      ),
      component: (
        <PlansSection
          billingPlans={billingPlans}
          isSalesBtnisvisible={isSalesBtnisvisible}
          userDetails={userDetails}
        />
      ),
    },
    {
      id: "extras",
      title: (
        <Flex alignItems="center" gap={2}>
          <FaPlusSquare />
          Extras
        </Flex>
      ),
      component: (
        <ExtrasSection
          userDetails={userDetails}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
        />
      ),
    },
  ];

  return (
    <Flex direction={"column"} gap={3} w={"100%"} h={"100%"}>
      <Flex gap={2} w={"100%"} alignItems="center" p={2}>
        <Heading color={textColor} fontSize="xl">
          {myDetails?.agency_id ? "Billing" : "Billing & Wallet"}
        </Heading>
      </Flex>
      {isLoading && <Loader />}
      <Accordion
        defaultIndex={sections.map((_, index) => index)}
        allowMultiple
        gap={2}
        overflowY={"auto"}
      >
        {sections.map(({ id, title, component }) => (
          <Card my={2}>
            <AccordionItem
              key={id}
              border={"none"}
              borderBottom={"0 !important"}
            >
              <h2>
                <AccordionButton>
                  <Box as="span" flex="1" textAlign="left" fontWeight="bold">
                    {title}
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>{component}</AccordionPanel>
            </AccordionItem>
          </Card>
        ))}
      </Accordion>
    </Flex>
  );
};

export default Billing;
